// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-51b7db4b] {\n  margin: 10px 0;\n}\n.card[data-v-51b7db4b]:first-child {\n  margin-top: 0;\n}\n.card[data-v-51b7db4b]:last-child {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
